﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListFakturaAdbChoose extends GuiListGeneric {

        constructor() {
            super("FakturaAdb");
        }

        protected clickRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement> ) {
            e.preventDefault();
            const fakturaId = $("#FakturaId").val();
            const id = $(e.target).closest("div.erz-list-element").data("id");
            const selectUrl = $("div.erz-list").data("select-url");
            const url = `${selectUrl}?fakturaId=${fakturaId}&adbId=${id}`;
            this.gotoUrl(url);
        }
    }
